import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ISimpleData } from '../../../../../shared/models/simpleData.model';
import { GeneralSettingsService } from '../../../../../services/general-settings.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../../../../../services/toast.service';

@Component({
  selector: 'app-add-edit-measurement-units-dialog',
  templateUrl: './add-edit-measurement-units-dialog.component.html',
  styleUrls: ['./add-edit-measurement-units-dialog.component.scss']
})
export class AddEditMeasurementUnitsDialogComponent implements OnInit {

  form?: FormGroup;
  isBusy = false;
  @Input() measurementUnit?: ISimpleData;
  constructor(private generalSettingsService: GeneralSettingsService, private activeModal: NgbActiveModal, private toastService: ToastService) { }

  ngOnInit(): void {
    this.form = new FormGroup({
      code: new FormControl(this.measurementUnit?.code || '', Validators.required),
      description: new FormControl(this.measurementUnit?.description || '', Validators.required)
    });
  }

  closeModal(reason?: any) {
    this.activeModal.dismiss(reason);
  }

  onSaveClick() {
    const data = { ...this.form.value, id: this.measurementUnit?.id };
    this.isBusy = true;
    this.generalSettingsService.saveMeasurementUnit(data).subscribe((result) => {
      if(result?.id) {
        this.toastService.showSuccess("Measurement unit has been saved");
        this.closeModal(true);
      }
      this.isBusy = false;
    });
  }

}
